/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { MyLibraryPersonViewModel } from "../types/MyLibraryPersonViewModel.ts";

export const myLibraryPersonViewModelSchema = z.object({
  id: z.optional(
    z
      .number()
      .int()
      .describe("ID do vínculo da pessoa com a biblioteca digital."),
  ),
  personId: z.optional(z.number().int().describe("ID da pessoa integrada.")),
  personName: z.string().describe("Nome completo da pessoa.").nullish(),
  personEmail: z
    .string()
    .describe(
      "E-mail da pessoa, que também é o nome de usuário na biblioteca digital.",
    )
    .nullish(),
}) as unknown as ToZod<MyLibraryPersonViewModel>;
